
/**
 * @export
 * @enum {string}
 */
export enum ContractChangeType {
    NEW_CONTRACT = 'NEW_CONTRACT',
    CONTRACT_EDIT = 'CONTRACT_EDIT',
    CREDIT_CHANGE = 'CREDIT_CHANGE',
    CONTRACT_MOVED_TO_PAST = 'CONTRACT_MOVED_TO_PAST',
    CONTRACT_MOVED_TO_ACTIVE = 'CONTRACT_MOVED_TO_ACTIVE'
}